import { get, patch, post, remove } from '@/api/base'

const notificationTopicsApi = {
  getAll: async companyUuid => {
    const response = await get({
      path: 'notification_topics',
      params: { company_uuid: companyUuid },
    })
    return response.success ? response.data.notification_topics : response
  },
  get: async topicUuid => {
    const response = await get({
      path: `notification_topics/${topicUuid}`,
    })
    return response.success ? response.data.notification_topic : null
  },
  create: async topicParams => {
    return await post({
      path: `notification_topics`,
      params: topicParams,
    })
  },
  update: async (topicUuid, params) => {
    const response = await patch({
      path: `notification_topics/${topicUuid}`,
      params,
    })
    return response.success ? response.data.notification_topic : null
  },
  delete: async topicUuid => {
    return await remove({
      path: `notification_topics/${topicUuid}`,
    })
  },
}

export default notificationTopicsApi
